import { Injectable } from "@angular/core";
import { AuthenticationResponse } from "@models/account/account.model";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UserHelperService {
  private userName = new BehaviorSubject("");
  private isCurrentUserAdmin = new BehaviorSubject(false);
  private currentTenantId = new BehaviorSubject("");
  private isEmotionTransferActivated = new BehaviorSubject(false);
  sharedUserName = this.userName.asObservable();
  sharedUserType = this.isCurrentUserAdmin.asObservable();
  sharedTenantId = this.currentTenantId.asObservable();
  sharedEmotionTransferActivated =
    this.isEmotionTransferActivated.asObservable();

  constructor() {}

  public static getUserIdFromLocalStorage() {
    const token = localStorage.getItem("session");
    let userId;
    if (!!token) {
      const authResponseFromStorage = JSON.parse(
        token
      ) as AuthenticationResponse;
      if (authResponseFromStorage) {
        userId = authResponseFromStorage.userId;
      }
    }
    return userId;
  }

  public static getEmotionTransferFromLocalStorage() {
    const token = localStorage.getItem("session");
    let emotionTransfer;
    if (!!token) {
      const authResponseFromStorage = JSON.parse(
        token
      ) as AuthenticationResponse;
      if (authResponseFromStorage) {
        emotionTransfer = authResponseFromStorage.emotionTransfer;
      }
    }
    return emotionTransfer;
  }

  setUserName(name: string) {
    this.userName.next(name);
  }

  setUserType(isAdmin: boolean) {
    this.isCurrentUserAdmin.next(isAdmin);
  }
  setTenantId(tenantId: string) {
    this.currentTenantId.next(tenantId);
  }
  setEmotionTransferActivated(emotionTransfer: boolean) {
    this.isEmotionTransferActivated.next(emotionTransfer);
  }

  public static isEmotionTransferFeatureEnabled(): boolean {
    const token = localStorage.getItem("session");
    const session = token
      ? (JSON.parse(token) as AuthenticationResponse)
      : null;
    return !!session?.emotionTransferFeatureEnabled;
  }

  updateCurrentUserFeatureFlags(flags: {
    emotionTransfer: boolean;
    emotionTransferFeatureEnabled: boolean;
  }) {
    const token = localStorage.getItem("session");
    if (token) {
      const session = JSON.parse(token) as AuthenticationResponse;
      session.emotionTransfer = flags.emotionTransfer;
      session.emotionTransferFeatureEnabled =
        flags.emotionTransferFeatureEnabled;
      localStorage.setItem("session", JSON.stringify(session));
    }
    this.setEmotionTransferActivated(flags.emotionTransfer);
  }

  updateCurrentUserEmotionTransfer(emotionTransfer: boolean) {
    const effectiveValue =
      UserHelperService.isEmotionTransferFeatureEnabled() && !!emotionTransfer;
    const token = localStorage.getItem("session");
    if (token) {
      const session = JSON.parse(token) as AuthenticationResponse;
      session.emotionTransfer = effectiveValue;
      localStorage.setItem("session", JSON.stringify(session));
    }
    this.setEmotionTransferActivated(effectiveValue);
  }
}
